var awsconfig = {
    accessKeyId: "AKIASQX7FKZZPQYZ6M6R",
    secretAccessKey: "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",
    region: "us-east-1",
  };


export default awsconfig;
